import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateShiftScheduleFilter } from "@/reducers/clientdashboard";

/**
 * Generates a list of shift schedule types and handles the selection of active schedule type.
 *
 * @return {JSX.Element} The rendered list of shift schedule types.
 */
export const ShiftScheduleTypesList = ({ year = "month" }) => {
  const dispatch = useDispatch();
  const { isPremiumAccount } = useSelector((state) => state.session);
  const { shiftCalendarLoading, shiftScheduleFilter } = useSelector(
    (state) => state.clientDashboard,
  );
  const arr = [
    ...(isPremiumAccount
      ? [
          {
            name: "Unfilled",
            cls: "text-red bg-red-150 hover:bg-red-200",
            status: "unfilled",
            activeCls: "bg-red",
          },
          {
            name: "Awaiting Approval",
            cls: "text-yellow bg-yellow-150 hover:bg-yellow-200",
            status: "awaiting_approval",
            activeCls: "bg-yellow",
          },
        ]
      : []),
    {
      name: "Booked",
      cls: "text-green bg-green-150 hover:bg-green-200",
      status: "booked",
      activeCls: "bg-green",
    },
  ];
  return (
    <div className="ShiftScheduleTypesList_Wrapper sm:max-lg:grow">
      <div className="flex gap-4 sm:max-lg:flex-col">
        {arr.map((item, index) => {
          const { name, cls, status, activeCls } = item;
          return (
            <div
              className={`flex h-[40px] items-center gap-2 rounded-lg p-[3px_10px] ${shiftCalendarLoading ? "pointer-events-none" : ""} ${status === shiftScheduleFilter.shift_status || !isPremiumAccount ? `text-white ${activeCls}` : cls} cursor-pointer transition-all duration-200 ease-linear`}
              key={index}
              onClick={() => {
                if (shiftCalendarLoading || !isPremiumAccount) return;
                if (shiftScheduleFilter.shift_status === status) {
                  dispatch(
                    updateShiftScheduleFilter({
                      shift_status: "",
                      shift_type: year,
                    }),
                  );
                } else {
                  dispatch(
                    updateShiftScheduleFilter({
                      shift_status: status,
                      shift_type: year,
                    }),
                  );
                }
              }}
            >
              <p className="text-[12px] font-medium leading-[normal] lg:text-[14px]">
                {name}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
